import { dayjs } from "./time";
import { DtConstants } from "../../schema/DtConstants";

const { Now } = DtConstants.Timeline;

/** Time of interest, either symbolic or explicit timestamp */
export class FocusedTime {
  /** @type {MaybeNowTS} Selected/Focused point of time in the interval */
  focus;

  constructor(focus) {
    this.focus = focus;
  }

  /** Milliseconds elapsed between chosen time and now. */
  ago() {
    return this.focus === Now ? 0 : Date.now() - this.focus;
  }

  /** ensures focused time stays within the time interval. */
  clamp(interval) {
    const now = Date.now();
    const realFocus = resolve(this.focus, now);

    if (interval.end === Now && realFocus >= now) {
      if (this.focus === Now) return false;
      this.focus = Now;
      return true;
    }

    const realEnd = resolve(interval.end, now);
    const inclusiveEnd = realEnd - 1;
    const clampedFocus = clamp(realFocus, realEnd - interval.duration.asMilliseconds(), inclusiveEnd);

    if (clampedFocus !== realFocus) {
      this.focus = clampedFocus;
      return true;
    }
  }

  /** Is this time strictly after the interval */
  isAfter(interval) {
    if (this.focus === interval.end) return false;

    const now = Date.now();
    return resolve(this.focus, now) > resolve(interval.end, now);
  }

  /** Is symbolic "Now" (ie Live) */
  isLive() {
    return this.focus === Now;
  }

  /**
   * Focused time as a timestamp or DayJS datetime if passed a Timezone.
   * @param {string} [tzId] TZ Database timezone identifier. Defaults to user's
   * @param {number} [now] Optional override on what is now, as a UNIX timestamp.
   * @return {number|dayjs.Dayjs}
   */
  resolve(tzId, now = Date.now()) {
    return dayjs(resolve(this.focus, now)).tz(tzId);
  }
}

const resolve = (optSymbolic, now) => optSymbolic === Now ? now : optSymbolic;
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);